import { FC } from "react";

import { FormBuilder } from "shared/components";

import { getFields } from "./formData";
import { VenueBlockFormContainer } from "./styles";

interface VenueBlockFormProps {
  defaultValues?: Record<string, any>;
  handleSubmit: (data: { title: string }) => void;
  handleTitleChange: (title: string | null) => void;
}

export const VenueBlockForm: FC<VenueBlockFormProps> = ({
  defaultValues,
  handleTitleChange,
  handleSubmit,
}) => {
  return (
    <VenueBlockFormContainer>
      <FormBuilder
        fields={getFields({ handleTitleChange })}
        onSubmit={handleSubmit}
        defaultValues={defaultValues}
        globalError
      />
    </VenueBlockFormContainer>
  );
};
